import { useEffect, useState } from "react";
import Alert from "react-bootstrap/Alert";
import TextInput from "../TextInput";
import EmailUtil from "../../../utils/EmailUtil";
import Translated from "../Translated";
import Spinner from "../Spinner";
import { useVerifyEmail } from "../../../api-new";
import { useTranslation } from "../TranslationProvider";

const ProductInputEmailCredential = (props) => {
  const { translate } = useTranslation();
  const [inputs, setInputs] = useState({
    email: "",
    emailAgain: "",
    name: "",
  });
  const [error, setError] = useState(null);
  const verifyEmailQuery = useVerifyEmail(inputs.email);

  useEffect(() => {
    const [areValid, error] = validateInputs();
    if (areValid) {
      verifyCanUseEmail();
    } else {
      setError(error);
      props.addComponentInput(props.component.id, null);
    }
  }, [inputs]);

  const validateInputs = () => {
    let error;
    if (!inputs.name.trim()) {
      error = "invalid-input";
    } else if (!EmailUtil.isEmail(inputs.email.trim())) {
      error = "invalid_email_form";
    } else if (
      inputs.email.trim().toLowerCase() !==
      inputs.emailAgain.trim().toLowerCase()
    ) {
      error = "email-mismatch";
    }
    return [!error, error];
  };

  const verifyCanUseEmail = async () => {
    const { data, isError } = await verifyEmailQuery.refetch();
    if (isError) {
      setError(data.error.message);
      return;
    }

    if (data.email !== inputs.email) {
      setInputs((prev) => ({
        ...prev,
        email: data.email.trim(),
        emailAgain: data.email.trim(),
      }));
      return;
    }

    const isAllowedAddress = data.isAllowedAddress;
    if (!isAllowedAddress) {
      setError("email_not_valid_for_purchases");
    } else {
      setError(null);
      // Email is verified to be ok. Pass the input to the parent component.
      props.addComponentInput(props.component.id, {
        email: inputs.email,
        name: inputs.name,
      });
    }
  };

  const updateInputValue = (prop, value) => {
    setInputs((prev) => ({ ...prev, [prop]: value }));
  };

  const renderComponent = (props) => {
    const emailText = translate("email_address");
    const emailAgainText = translate("email_address_again");
    const nameText = translate("name");

    return (
      <div key={props.id}>
        <h3>
          <Translated translationKey={props.title} />
        </h3>

        <div className="first-content bottom-margin">
          <Translated translationKey="email_credentials_info" />
        </div>

        <TextInput
          listener={(name) => updateInputValue("name", name)}
          label={nameText}
          placeholder={nameText}
          value={inputs.name}
          className="long-input-field"
        />

        <TextInput
          listener={(email) => {
            email = email.replace(/ /g, "");
            updateInputValue("email", email);
          }}
          type="email"
          label={emailText}
          placeholder={emailText}
          value={inputs.email}
          className="long-input-field"
        />

        <TextInput
          listener={(email) => {
            email = email.replace(/ /g, "");
            updateInputValue("emailAgain", email);
          }}
          type="email"
          label={emailAgainText}
          placeholder={emailAgainText}
          value={inputs.emailAgain}
          className="long-input-field"
        />
        {renderError()}
        {verifyEmailQuery.isFetching && <Spinner />}
      </div>
    );
  };

  const renderError = () => {
    return (
      props.showErrors &&
      error && (
        <Alert>
          <Translated translationKey={error} />
        </Alert>
      )
    );
  };

  return <div>{renderComponent(props.component)}</div>;
};

export default ProductInputEmailCredential;
